import * as React from 'react'
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Dashboard from './dashboard/Dashboard';
import UpgradePage from './upgrade/UpgradePage';
import SignIn from './sign-in/SignIn'
import ResetPassword from './sign-in/ResetPassword'
import Register from './register/Register'
import LoadingProgress from './register/LoadingProgress';
import TermsPage from './terms/TermsPage';
import PrivacyPage from './privacy/PrivacyPage';
import LandingPage from './landing/LandingPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<SignIn />} />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<Dashboard />} />
        <Route path="/upgrade" element={<UpgradePage />} />
        <Route path="/load" element={<LoadingProgress open={true} loadedTo="12 Nov 2023" progress={0} />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/logout" element={<SignIn logout={true} />} />
      </Routes>
    </div>
  );
}

export default App;

